import { RevealGroup, RevealItem } from "@/components/site/Reveal";
import { Counter } from "@/components/site/Counter";

export const StatsGrid = ({ stats = [] }) => {
  const parse = (s) => {
    // value already numeric; suffix like "+", "%", " days"
    return s;
  };
  return (
    <section className="section-py" data-testid="stats-section">
      <div className="container-bp">
        <RevealGroup className="grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-4">
          {stats.map((s) => (
            <RevealItem key={s.id}>
              <div className="relative text-center md:text-left">
                <p className="font-display text-5xl font-semibold text-[color:var(--bp-gold)] sm:text-6xl">
                  <Counter value={s.value} suffix={s.suffix} />
                </p>
                <p className="mt-3 text-[14px] font-semibold text-[color:var(--bp-cream)]">{s.label}</p>
                <p className="mt-1 text-[12.5px] leading-snug text-[color:var(--bp-text-muted)]">{s.context}</p>
              </div>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};
